import { useEffect, useState } from "react";
import { API, api } from "@/lib/api";

let cached = null;
const listeners = new Set();

export const logoUrl = (branding) =>
  branding?.has_logo ? `${API}/branding/logo?v=${branding.logo_version || 0}` : null;

export const setBrandingCache = (data) => {
  cached = data;
  listeners.forEach((fn) => fn(data));
};

export const useBranding = () => {
  const [branding, setBranding] = useState(cached);

  useEffect(() => {
    listeners.add(setBranding);
    if (!cached) {
      api
        .get("/branding")
        .then(({ data }) => setBrandingCache(data))
        .catch(() => {});
    }
    return () => listeners.delete(setBranding);
  }, []);

  return branding;
};

/** The chambers letterhead that heads every sheet, brief and kit — on screen and in print. */
export const Letterhead = ({ className = "" }) => {
  const branding = useBranding();
  if (!branding) return null;
  const logo = logoUrl(branding);
  const lines = [branding.line1, branding.line2, branding.line3].filter(Boolean);

  return (
    <div
      data-testid="letterhead"
      className={`flex items-center gap-4 border-b-2 border-primary/70 pb-3 ${className}`}
    >
      {logo ? (
        <img
          src={logo}
          alt=""
          data-testid="letterhead-logo"
          className="h-14 w-auto max-w-[10rem] object-contain"
          style={{ printColorAdjust: "exact", WebkitPrintColorAdjust: "exact" }}
        />
      ) : null}
      <div className="min-w-0">
        <p className="font-heading text-lg font-bold leading-tight" data-testid="letterhead-name">
          {branding.name}
        </p>
        {lines.map((line) => (
          <p key={line} className="text-xs text-muted-foreground leading-snug">
            {line}
          </p>
        ))}
      </div>
    </div>
  );
};
